import { render } from "./CheckboxClassicField.vue?vue&type=template&id=0402538e"
import script from "./CheckboxClassicField.vue?vue&type=script&lang=js"
export * from "./CheckboxClassicField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__